<template>
    <div class="condition-content">
        <vm-select-business-popper
            ref="second"
            :config="selectorConfig"
            @submit="onVmSelectSubmit"
        >
            <div
                :class="{ 'is-placeholder': !hasValue }"
                class="rule-org-select-trigger"
            >
                {{ hasValue ? showTxt : '请选择' }}<v-icon name="arrow_dropdown" />
            </div>
        </vm-select-business-popper>
        <!-- <org-select-pop
            mode="pop"
            :single="false"
            :depart-can-select="true"
            :selected="selectedList"
            title-selected="已选员工/部门"
            subtitle="选择员工/部门"
            @confirm="onSelectConfirm"
        >
            <div slot="trigger" class="rule-org-select-trigger" :class="{ 'is-placeholder': !hasValue }">
                {{ hasValue ? showTxt : '请选择' }}<v-icon name="arrow_dropdown"></v-icon>
            </div>
        </org-select-pop> -->
    </div>
</template>

<script>
import VmSelectBusinessPopper from '@/components/vm-select-business-popper';
// import OrgSelectPop from 'src/components/org-select';

export default {
  name: 'OrgSelect',

  components: {
    // OrgSelectPop,
    VmSelectBusinessPopper,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    const currentValue = this.value || [];
    const selectedList = this.transToFormat(currentValue);

    return {
      currentValue,
      selectedList,
      valid: true,
      selectorConfig: {
        tabs: {
          // 同事数据源标识
          colleague: {
            selected: selectedList, // 默认已选id
            checkStrictly: true, // 严格模式，父子不相关
          },
        },
        multiple: true, // 多选/单选
        maxLength: 0, // 最大可选数 ，0 表示不限制,
        layout: {
          search: true, // 是否展示搜索，默认true
          list: true, // 是否展示列表 默认true
          status: true, // 是否展示已选数。默认 true
          action: {
                    	selectAll: false, // 是否展示 全选/取消
                    	btn: true, // 提交按钮是否展示
          },
          selected: true, // 是否展示已选列表， 默认true
        },
        withCheckbox: false, // 是否展示checkbox
      },
    };
  },
  computed: {
    brief() {
      return `${this.optionInfo.text}为${this.showTxt}`;
    },

    hasValue() {
      return this.currentValue && this.currentValue.length > 0;
    },

    showTxt() {
      const showArr = [];
      const staffArr = [];
      const departArr = [];

      this.selectedList.forEach((item) => {
        const { isFolder } = item || {};
        if (isFolder) {
          departArr.push(item);
        } else {
          staffArr.push(item);
        }
      });

      if (staffArr.length > 0) {
        if (staffArr.length > 1) {
          showArr.push(`${staffArr[0].name.replace(/\([^)]*\)$/, '')}等${staffArr.length}人`);
        } else {
          showArr.push(staffArr[0].name.replace(/\([^)]*\)$/, ''));
        }
      }

      if (departArr.length > 0) {
        if (departArr.length > 1) {
          showArr.push(`${departArr[0].name}等${departArr.length}个部门`);
        } else {
          showArr.push(departArr[0].name);
        }
      }

      return showArr.join('/');
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
      this.selectedList = this.transToFormat(this.currentValue);
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    onVmSelectSubmit(data) {
      const { colleague } = data || {};
      this.onChange(this.formatListData(colleague));
    },

    getValidate() {
      return !!(this.currentValue.length && this.currentValue.length > 0);
    },
    validate() {
      this.valid = this.getValidate();
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        operation: 'arrayInclude',
        name: this.optionInfo.value,
        type: 'array',
        value: JSON.stringify(value),
      };

      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: this.getValidate(),
      });
    },

    onSelectConfirm(list) {
      this.onChange(this.formatListData(list));
    },

    formatListData(list) {
      return list.map((item) => {
        const { id, name, isFolder, isParent, gender } = item || {};
        let type = 1;

        if (isFolder || isParent) {
          type = 2;
        }

        return {
          id,
          name,
          type,
          gender,
        };
      });
    },

    transToFormat(arr) {
      return arr.map((item) => {
        const { id, name, type, gender } = item || {};
        let isFolder = false;

        if (parseInt(type, 10) === 2) {
          isFolder = true;
        }

        return {
          id,
          name,
          isFolder,
          gender: parseInt(gender, 10),
        };
      });
    },
  },
};
</script>

<style scoped lang="less">
.rule-org-select-trigger {
    display: inline-block;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;

    &.is-placeholder {
        color: #a8abb3;
    }

    .v-icon {
        color: #a8abb3;
        margin-left: 5px;
        width: 10px;
        height: 10px;
    }
}
</style>
